import { StylesQuery } from '../../FormSteps/Styles/StylesInput'
import { FacilitiesQuery } from '../../../Views/FormSteps/Facilities/FacilitiesInput.generated'
import ListItem from '../Base/SummaryList/Item/ListItem'
import BaseSummaryList from '../Base/SummaryList'
import useBriefContext from '../../../Hooks/Brief/useBriefContext'
import isDirectEnquiryBrief from '../../../Logic/Form/Sequences/DirectEnquiry/isDirectEnquiryBrief'
import EditLink from '../Base/SummaryList/EditLink'
import { formatTimings, formatBudget, formatEventType } from '../Base/Utilities/format'
import './SummaryList.less'
import TimingFlexibilityListItem from './ListItems/TimingFlexibility'
import { formatAsQuote } from '../Base/Utilities/format'
import { formatLayout as formatLFLayout } from './Utilities/format'

interface LFSummaryListProps {
  features?: FacilitiesQuery['collection']['features']
  styles?: StylesQuery['getAllStyles']
}

const LFSummaryList = ({ features, styles }: LFSummaryListProps): JSX.Element => {
  const { brief } = useBriefContext()
  const selectedFeatures = features
    ? brief.spaceFacilityIds?.map(
        (selectedID) => features.find(({ id }) => selectedID === parseInt(id, 10))?.name
      )
    : undefined
  const selectedStyles = styles
    ? brief.styleIds?.map((selectedID) => styles.find(({ id }) => id === selectedID)?.label)
    : undefined

  return (
    <BaseSummaryList
      className='lf-summary'
      heading={
        <>
          <h2>{brief.eventName}</h2>
          <EditLink path={'name'} sectionLabel='event name' />
          <p className='caption' aria-hidden='true'>
            One last check before we share your enquiry.
          </p>
        </>
      }>
      <ListItem path='type' label='Event type'>
        {formatEventType(brief)}
      </ListItem>

      <ListItem path='location' label='Preferred location' editable={!isDirectEnquiryBrief(brief)}>
        {`${brief.location} + ${brief.radius}km`}
      </ListItem>

      <ListItem path='guests' label='Attendees'>
        {brief.capacities} guests{formatLFLayout(brief)}
      </ListItem>

      <ListItem path='timings' label='Date & time'>
        {formatTimings(brief)}
      </ListItem>

      <TimingFlexibilityListItem brief={brief} />

      <ListItem path='budget' label='Budget'>
        {formatBudget(brief)}
      </ListItem>

      <ListItem path='style' label='Venue styles'>
        {selectedStyles ? selectedStyles.join(', ') || 'None' : '...'}
      </ListItem>

      <ListItem path='extras' label='Facilities'>
        {selectedFeatures ? selectedFeatures.join(', ') || 'None' : '...'}
      </ListItem>

      <ListItem path='extras' elementID='catering-needs' label='Catering requests'>
        {formatAsQuote(brief.cateringNeeds)}
      </ListItem>

      <ListItem path='name' elementID='additional-notes' label='Additional notes'>
        {formatAsQuote(brief.additionalNotes)}
      </ListItem>
    </BaseSummaryList>
  )
}

export default LFSummaryList
